import { getHSLAColorHash, hslaToRGBA, rgbaString } from '@/uiKit/colorPalette'

export const getAttributeColor = (label: string): string => {
  const hsla = getHSLAColorHash(label)
  hsla.l = 70
  return rgbaString(hslaToRGBA(hsla))
}
